// extracted by mini-css-extract-plugin
module.exports = {"root":"PdpCarDetail_root__tmAzj","leftContainer":"PdpCarDetail_leftContainer__O_dUj","title":"PdpCarDetail_title__w6_iI","value":"PdpCarDetail_value__ylFka"};